import { lazy } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router";
import { useAuth } from "@/context/AuthProvider";
//**
// Marketing Pages
//  */
const MarketingLayout = lazy(() => import("@pages/Marketing/Layout/index.tsx"));
// const Home = lazy(() => import("@pages/Marketing/Home"));
const Pricing = lazy(() => import("@pages/Marketing/Pricing/index.tsx"));
const About = lazy(() => import("@pages/Marketing/About/index.tsx"));

// Products
// Product Detail Pages
import InsightDetail from "@/pages/Product/Insight/InsightDetail";
const QuickReports = lazy(
  () => import("@/pages/Marketing/Products/QuickReports")
);

// Products End

// Footer Pages
const TermsOfService = lazy(
  () => import("@pages/Marketing/Footer/TermsOfService/index.tsx")
);
const Contact = lazy(() => import("@pages/Marketing/Footer/Contact/index.tsx"));
const PrivacyPolicy = lazy(
  () => import("@pages/Marketing/Footer/PrivacyPolicy/index.tsx")
);

//**
// Marketing Pages End
//  */

// Store & Account Pages
const CreateInsight = lazy(() => import("@pages/Store/CreateInsight"));
const Account = lazy(() => import("@pages/Account/ManageAccount"));
const Purchases = lazy(() => import("@pages/Account/Purchases"));
const Login = lazy(() => import("@pages/Account/Login/index.tsx"));
const CreateAccount = lazy(() => import("@/pages/Account/Create"));

// Order Pages
const Cart = lazy(() => import("@pages/Order/Cart"));
const Checkout = lazy(() => import("@pages/Order/Checkout"));
const OrderSuccess = lazy(() => import("@pages/Order/OrderSuccess"));

// Product Info Pages
const AboutInsights = lazy(
  () => import("@pages/Marketing/Products/Insights/index.tsx")
);

// Store Pages
const StoreLayout = lazy(() => import("@pages/Store/Layout/index.tsx"));

const AuthenticatedRoute = ({ children }: { children: JSX.Element }) => {
  const authContext = useAuth();
  const { isAuthenticated, isLoading } = authContext;
  const location = useLocation();
  if (!isAuthenticated && !isLoading) {
    // TODO if is loading, show loading spinner
    return <Navigate to="/account/login" state={{ from: location }} replace />;
  }
  return children;
};

const AnonymousRoute = ({ children }: { children: React.ReactNode }) => {
  const authContext = useAuth();
  const { isAuthenticated, isLoading } = authContext;
  const { state } = useLocation();
  if (isAuthenticated && !isLoading)
    // TODO if is loading, show loading spinner
    return <Navigate to={state?.path || "/quick-reports"} replace />; // Navigate to the quick-reports page on login

  return children;
};

function Router() {
  return (
    <Routes>
      {/* Marketing */}
      <Route element={<MarketingLayout />}>
        <Route path="/" element={<Login />} />
        <Route path="about" element={<About />} />
        <Route path="pricing" element={<Pricing />} />
        <Route path="insights" element={<AboutInsights />} />
        <Route path="terms-of-service" element={<TermsOfService />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="contact" element={<Contact />} />
        <Route path="quick-reports" element={<QuickReports />} />
        <Route path="account">
          <Route
            path="login"
            element={
              <AnonymousRoute>
                <Login />
              </AnonymousRoute>
            }
          />
          <Route
            path="create"
            element={
              <AnonymousRoute>
                <CreateAccount />
              </AnonymousRoute>
            }
          />
        </Route>
      </Route>
      {/* Ecommerce */}
      <Route element={<StoreLayout />}>
        <Route
          path="insight/new"
          element={
            <AuthenticatedRoute>
              <CreateInsight />
            </AuthenticatedRoute>
          }
        />
        <Route path="account">
          <Route
            index
            element={
              <AuthenticatedRoute>
                <Account />
              </AuthenticatedRoute>
            }
          />
          <Route
            path="purchases"
            element={
              <AuthenticatedRoute>
                <Purchases />
              </AuthenticatedRoute>
            }
          />
        </Route>
        <Route path="order">
          <Route
            path="cart"
            element={
              <AuthenticatedRoute>
                <Cart />
              </AuthenticatedRoute>
            }
          />
          <Route
            path="checkout"
            element={
              <AuthenticatedRoute>
                <Checkout />
              </AuthenticatedRoute>
            }
          />
          <Route
            path="success"
            element={
              <AuthenticatedRoute>
                <OrderSuccess />
              </AuthenticatedRoute>
            }
          />
          <Route
            path=":orderId/insight/:itemId"
            element={
              <AuthenticatedRoute>
                <InsightDetail />
              </AuthenticatedRoute>
            }
          />
        </Route>
      </Route>
    </Routes>
  );
}

export default Router;
